import { createIcon } from "@chakra-ui/react";

export const Calendar = createIcon({
  displayName: "Calendar",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2a1.25 1.25 0 0 0-1.25 1.25V4.5H4.5A2.5 2.5 0 0 0 2 7v12.5A2.5 2.5 0 0 0 4.5 22h15a2.5 2.5 0 0 0 2.5-2.5V7a2.5 2.5 0 0 0-2.5-2.5h-1.25V3.25a1.25 1.25 0 0 0-2.5 0V4.5h-7.5V3.25A1.25 1.25 0 0 0 7 2zm0 6.25a1.25 1.25 0 0 0 0 2.5h10a1.25 1.25 0 0 0 0-2.5H7z"
    />,
  ],
  defaultProps: {
    "aria-label": "A calendar symbol"
  }
});

export default Calendar;
